import * as React from 'react';
import { Dialogs } from './DialogsEnum';

// eslint-disable-next-line no-use-before-define
export interface DialogToggleDefaults {
  openDialog: Dialogs;
  toggleDialog: (dialog: Dialogs | string) => void;
}

const DialogToggleDefaults: DialogToggleDefaults = {
  openDialog: Dialogs.None,
  toggleDialog: (dialog: Dialogs) => {
    return dialog ? undefined : undefined;
  },
};

export const {
  Provider: DialogToggleProvider,
  Consumer: DialogToggleConsumer,
} = React.createContext(DialogToggleDefaults);

export function withDialogToggle<P extends DialogToggleDefaults>(
  Component: React.ComponentType<P>,
) {
  return function DialogComponent(
    props: Pick<P, Exclude<keyof P, keyof DialogToggleDefaults>>,
  ) {
    return (
      <DialogToggleConsumer>
        {dialogProps => (
          // @ts-ignore: Type 'Pick<P, Exclude<keyof P, "c4cMode">> & Case4CauseToggleDefaults' is not assignable to type 'P'.
          <Component {...props} {...dialogProps} />
        )}
      </DialogToggleConsumer>
    );
  };
}
